export default __webpack_public_path__ + "static/google-store-8fe5e28b9f7013fc6be5055e1b93591b.png";